import 'core-js/actual/object';
import ClipboardJS from 'clipboard';
// @ts-ignore
// import ClipboardJS from 'clipboard';

import { getActivityConfig, getQueryParam, isFacebook, isInstagram, isIOS, isQQ, isWeChat, json_decode, registerDeeplinkButton } from './libs/utils';
import { getCurrentLanguage } from './libs/i18n';
import './libs/reporter';

let inviteInfo:pandoraDataType = {
    appId:"2237",
    code:"MU6AA3LB",
    module:"SettlementScheme",
    type:"Invite",
    userName:"zacklli"
};
/**
 * 活动结束
 */
// function updatePageEnd() {
//     const mainElement = document.querySelector('.main') as HTMLElement;
//     const notMainElement = document.querySelector('.not-main') as HTMLElement;
//     const headerElement = document.querySelector('.header') as HTMLElement;
//
//     mainElement.style.display = 'none';
//     notMainElement.style.display = 'block';
//     headerElement.style.display = 'none';
// }

function updatePageInfo() {
    console.log('[updatePageInfo]', inviteInfo);
    const spans: HTMLElement[] = (document.querySelectorAll('div.code i') || []) as any;
    spans.forEach((dom) => {
        dom.innerHTML = '';
        dom.style.display = 'none';
    });

    // 更新界面展示的邀请码
    inviteInfo.code?.split('').forEach((v, i) => {
        if (!spans[i]) return;
        spans[i].style.display = '';
        spans[i].innerHTML = v;
    });

    // 用户昵称
    if (inviteInfo.type === 'Invite') {
        const el = document.querySelector('span.user-name');
        if (el) el.innerHTML = inviteInfo.userName ?? "";
    } else {
        // document.querySelector('div.desc')!.innerHTML = inviteInfo.cardName;
        const el = document.querySelector('div.desc');
        if (el) el.innerHTML = el.innerHTML.replace("{0}", inviteInfo.cardName ?? "");
    }

    // 头像
    // const headUrl = inviteInfo.playerHeadUrl as string;
    // (document.querySelector('div.icon img') as HTMLImageElement)!.src = inviteInfo.playerHeadUrl;
}

let strInviteInfo = getQueryParam('inviteInfo') || ''; // 获取链接传递邀请信息
strInviteInfo = decodeURIComponent(strInviteInfo); // url 编码
strInviteInfo = atob(strInviteInfo); // base64 解码

/**
 * 页面初始话操作
 */
function initPage() {
    // 设置默认语言
    const lang = getCurrentLanguage(language_data);
    app.switchLanguage(lang);

    console.log('[act] strInviteInfo =', strInviteInfo);

    inviteInfo = json_decode(strInviteInfo) ?? {};
    console.log('[act] inviteInfo =', inviteInfo);

    // 先对 inviteInfo 里的所有字段进行 urldecode
    for (const [k, v] of Object.entries(inviteInfo)) {
        if (!v || typeof v !== 'string') continue;
        inviteInfo[k] = decodeURIComponent(v);
    }
    // 邀请码
    // const code = inviteInfo.code;
    // 昵称
    // const nickName = inviteInfo.userName;

    // const passwordCode : string = inviteInfo.outStr;
    // app.passwordCode = inviteInfo.outStr;
    // if (nickName != null) {
    //     for (const [, arr] of Object.entries(language_data)) {
    //         arr.title3 = nickName;
    //     }
    // }
}

if(document.getElementById('copyCode')) {
    new ClipboardJS(document.getElementById('copyCode'), {
        text() {
            console.info('[Act] 复制邀请码:', inviteInfo.code);
            return inviteInfo.code;
        },
    });
}

function onError(err: ErrorEvent) {
    console.error('Uncaught error:', err.error || err.message || err, err);
}

// 全局未捕获错误处理
window.addEventListener('error', onError);

(async function () {
    initPage();
    // 复制并下载按钮点击事件处理
    registerDeeplinkButton('a.btn', strInviteInfo, undefined, () => {
        // iOS 平台下 Facebook 和 Instagram 下无法拉起客户端，需要弹窗提示用户复制链接在默认浏览器打开
        if (isFacebook()) {
            app.showTipBrowser('bottom');
            return false;
        }
        //指引
        if (isInstagram() || isWeChat() || isQQ()) {
            app.showTipBrowser('top');
            return false;
        }
    });

    await getActivityConfig(
        'a20240529anju',
        undefined,
        (data) => {
            console.log('拉取配置成功~==>', data);
            const { now, iActivityEndTime } = data;
            if (now >= iActivityEndTime) {
                // 活动结束
                // updatePageEnd();
            } else {
                updatePageInfo();
            }
        },
        (error) => {
            console.error('拉取配置失败~', error);
        },
    );
})();
